/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exit_ReaderInputs */

const en_exit_reader = /** @type {(inputs: Exit_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exit Reader`)
};

const id_exit_reader = /** @type {(inputs: Exit_ReaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluar dari Pembaca`)
};

/** @type {(inputs: Exit_ReaderInputs) => LocalizedString} */
const es_exit_reader = en_exit_reader;

/** @type {(inputs: Exit_ReaderInputs) => LocalizedString} */
const fr_exit_reader = en_exit_reader;

/** @type {(inputs: Exit_ReaderInputs) => LocalizedString} */
const de_exit_reader = en_exit_reader;

/** @type {(inputs: Exit_ReaderInputs) => LocalizedString} */
const ja_exit_reader = en_exit_reader;

/** @type {(inputs: Exit_ReaderInputs) => LocalizedString} */
const zh_exit_reader = en_exit_reader;

/** @type {(inputs: Exit_ReaderInputs) => LocalizedString} */
const ar_exit_reader = en_exit_reader;

/** @type {(inputs: Exit_ReaderInputs) => LocalizedString} */
const it_exit_reader = en_exit_reader;

/** @type {(inputs: Exit_ReaderInputs) => LocalizedString} */
const ru_exit_reader = en_exit_reader;

/** @type {(inputs: Exit_ReaderInputs) => LocalizedString} */
const pt_exit_reader = en_exit_reader;

/** @type {(inputs: Exit_ReaderInputs) => LocalizedString} */
const ko_exit_reader = en_exit_reader;

/**
* | output |
* | --- |
* | "Exit Reader" |
*
* @param {Exit_ReaderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const exit_reader = /** @type {((inputs?: Exit_ReaderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exit_ReaderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exit_reader(inputs)
	if (locale === "es") return es_exit_reader(inputs)
	if (locale === "fr") return fr_exit_reader(inputs)
	if (locale === "de") return de_exit_reader(inputs)
	if (locale === "ja") return ja_exit_reader(inputs)
	if (locale === "zh") return zh_exit_reader(inputs)
	if (locale === "ar") return ar_exit_reader(inputs)
	if (locale === "id") return id_exit_reader(inputs)
	if (locale === "it") return it_exit_reader(inputs)
	if (locale === "ru") return ru_exit_reader(inputs)
	if (locale === "pt") return pt_exit_reader(inputs)
	return ko_exit_reader(inputs)
});